export default __webpack_public_path__ + "static/media/Processing.e825f95b.svg";